export default __webpack_public_path__ + "static/media/pratap.b84090ac.jpg";